module.exports = __webpack_public_path__ + "img/book.d15edd50.png";